export const environment = {
  ns: 'DEVELOPMENT',
  production: false,
  cookieKey: 'pfm2-development',
  cookieBaseUrl: 'portfoliomanager2.blackforestbytes.com',
  apiBaseUrl: '/api/v2/',
};
